import React from "react";
import { RouteComponentProps } from "react-router-dom";
import GenericErrorPage from "../../../ErrorPages/Components/GenericErrorPage";

type TParams = {
  id: string;
};

export const AppNotFound: React.FC<RouteComponentProps<TParams>> = props => {
  const myDescription: string = `Could not find app with code "${props.match.params.id}"`;

  return (
    <GenericErrorPage
      src="https://http.cat/404"
      alt="Not Found"
      heading="App not Found!"
      description={myDescription}
    />
  );
};
